export default __webpack_public_path__ + "static/media/Mania-de-churrasco.7ff2d404.png";